var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center mb-4 space-x-1 cursor-pointer",attrs:{"variant":"secondary"},on:{"click":_vm.go}},[_c('span',[_vm._t("default",[_vm._v("Next")])],2),_c('ArrowRight',{staticClass:"w-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }